<button (click)="filterFavChanged()" style="margin-left: 15px; line-height: 14px !important" mat-icon-button>
  <mat-icon *ngIf="!isFavourite" style="font-size: 28px">star_border</mat-icon>
  <mat-icon *ngIf="isFavourite" style="font-size: 28px">star</mat-icon>
</button>
